/**
 * Sets up the idle timeout feature
 */
import { useEffect } from "react";
import { SURVEY_CONTENT, TOGGLE_IDLE } from "../../constants";

const useSurveyIdleTimeout = (props) => {
  useEffect(() => {
    if (!props.definition) return;

    const { definition, dispatch } = props;

    const {
      surveyDisplayConditions: { idleTimeOut },
    } = definition[SURVEY_CONTENT];

    let idleTime = 0;
    // eslint-disable-next-line no-unused-vars
    let isIdle = false;
    let idleInterval = 0;
    let idleForSeconds = idleTimeOut ? idleTimeOut * 1000 : 0;
    if (idleForSeconds >= 0) {
      const resetIdleTime = () => {
        idleTime = 0;
        isIdle = false;
      };
      //Idle Timeout events
      //Document
      document.addEventListener("onload", resetIdleTime, false);
      //Mouse
      document.addEventListener("click", resetIdleTime, false);
      document.addEventListener("mousedown", resetIdleTime, false);
      document.addEventListener("mouseup", resetIdleTime, false);
      document.addEventListener("mousemove", resetIdleTime, false);
      document.addEventListener("wheel", resetIdleTime, false);
      //Keyboard
      document.addEventListener("keydown", resetIdleTime, false);
      document.addEventListener("keyup", resetIdleTime, false);

      const checkIfIdle = () => {
        idleTime += 1000;

        if (idleTime >= idleForSeconds) {
          isIdle = true;
          clearInterval(idleInterval);
          dispatch({
            type: TOGGLE_IDLE,
            payload: true,
          });
        }
      };

      if (idleForSeconds >= 0) {
        idleInterval = setInterval(checkIfIdle, 1000); // Check every second if user is idle
      } else {
        dispatch({
          type: TOGGLE_IDLE,
          payload: true,
        });
      }
    }
  }, []);
};

export default useSurveyIdleTimeout;
